module.exports = __webpack_public_path__ + "static/commit-left-50a222942eb634feebece9d2203c26e5.png";